angular
    .module('app')
    .controller('ReportsController', function (
        $browser,
        $window,
        $timeout,
        $location,
        $uibModal,
        $routeParams,
        toastr,
        moment,
        ngProgressFactory,
        UserDetails,
        ReportAccessService
    ) {
        var vm = this;
        vm.state = {
            selectedReport: null,
            selectedTester: null,
            pills: false
        };

        vm.data = {};

        // If we navigate from another page to here and have a selected report we wish to display use it
        if ($routeParams.selectedReport != null) {
            vm.state.selectedReport = $routeParams.selectedReport;
        }
        if ($routeParams.testerId != null) {
            vm.state.selectedTester = $routeParams.testerId;
        }

        $window.vm = vm;
        vm.traceProgress = ngProgressFactory.createInstance();
        vm.showReport = showReport;

        function showReport(report) {
            vm.state.selectedReport = report;
        }

        function discardInvalid(reports) {
            // console.log(reports, "reports");
            //Remove any disabled reports
            reports = _.filter(reports, function (report) {
                return !report.IsDeleted;
            });
            return _.filter(reports, function (report) {
                return report.AssignedRoles.indexOf(vm.state.userDetails.Role) > -1;
            });
        }

        function init() {

            vm.traceProgress.start();
            UserDetails.get().then(function () {
                vm.traceProgress.complete();
                vm.data.reportAccess = ReportAccess_response.data;
                // ReportAccessService.getReportAccessGrid().then(function (reportGrid_response) {
                ReportAccessService.getReportAccessGridAsStringList().then(
                    function (reportGrid_response) {
                        vm.traceProgress.complete();
                        // console.log(reportGrid_response.data);
                        vm.data.reports = discardInvalid(
                            reportGrid_response.data
                        );
                    }
                );
            });
        }

        init();
    });
